// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{
    display: block;
}
.map-container {
    width: 100%;
  height: 100%;
  }
  
  #map-container {
    width: 100%;
    position: relative;
  }

  .search-bar {
    padding: 6px;
    box-sizing: border-box;
    font-size: 16px;
    z-index: 1;
    position: absolute;
    width: 300px;
    margin-left: 190px;
    margin-top: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/shared/google-geolocation/google-geolocation.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,WAAW;EACb,YAAY;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[":host{\n    display: block;\n}\n.map-container {\n    width: 100%;\n  height: 100%;\n  }\n  \n  #map-container {\n    width: 100%;\n    position: relative;\n  }\n\n  .search-bar {\n    padding: 6px;\n    box-sizing: border-box;\n    font-size: 16px;\n    z-index: 1;\n    position: absolute;\n    width: 300px;\n    margin-left: 190px;\n    margin-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
